import React from "react";
import {Checkbox, Col, Form, Row, Typography} from "antd";
import PropTypes from 'prop-types';

import {roundNumberUpToPrecision} from "../../helpers/misc";

const TaxCheckboxesInForm = ({taxes, handleTaxesApplied, disabled}) => {
    let component = null;

    if (taxes.length !== 0) {
        const checkboxes = taxes.map(tax => {
            const {name, full_name} = tax;

            const taxPercent = roundNumberUpToPrecision(tax.percent * 100, 2).toString();
            const nameJSX = <Typography.Text strong>{`${taxPercent}% ${name}`}</Typography.Text>;
            let fullNameJSX = null;
            if (
                name.toLowerCase().trim() !== full_name.toLowerCase().trim() &&
                full_name.trim() !== ''
            ) {
                fullNameJSX = ` (${full_name})`;
            }

            return <Col span={24} key={name}>
                <Checkbox onChange={handleTaxesApplied} value={name}><span>{nameJSX}{fullNameJSX}</span></Checkbox>
            </Col>;
        });
        component = <Form.Item label="Taxes: " name="Taxes">
            <Checkbox.Group disabled={disabled}>
                <Row gutter={[0, 12]}>
                    {checkboxes}
                </Row>
            </Checkbox.Group>
        </Form.Item>;
    }

    return component;
};

export default TaxCheckboxesInForm;

TaxCheckboxesInForm.propTypes = {
    taxes: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        percent: PropTypes.string,
        full_name: PropTypes.string,
    })).isRequired,
};
